/** Definisi rubrik penilaian — dipakai Asah (siswa) & GuruRubrikPanel. */
export const RUBRIK_ASPEK = [
  {
    no: 1,
    nama: 'Cerita',
    indikator: [
      { key: 'cerita_1', label: 'Judul mencerminkan isi cerita' },
      { key: 'cerita_2', label: 'Menghadirkan pesan yang jelas' },
    ],
  },
  {
    no: 2,
    nama: 'Efektivitas',
    indikator: [
      { key: 'efektivitas_1', label: 'Bahasa jelas, berdaya komunikatif' },
      { key: 'efektivitas_2', label: 'Berdaya pikat emosional' },
    ],
  },
  {
    no: 3,
    nama: 'Relevansi',
    indikator: [
      { key: 'relevansi_1', label: 'Kontekstual realitas kehidupan' },
      { key: 'relevansi_2', label: 'Kontekstual budaya / kearifan lokal' },
    ],
  },
  {
    no: 4,
    nama: 'Desain',
    indikator: [
      { key: 'desain_1', label: 'Kualitas gambar dan suara baik' },
      { key: 'desain_2', label: 'Pilihan gambar dan suara harmonis' },
    ],
  },
  {
    no: 5,
    nama: 'Akurasi',
    indikator: [
      { key: 'akurasi_1', label: 'Konten edukatif dan reflektif' },
      { key: 'akurasi_2', label: 'Kebenaran informasi valid' },
    ],
  },
  {
    no: 6,
    nama: 'Struktur',
    indikator: [
      { key: 'struktur_1', label: 'Kelengkapan unsur cerita' },
      { key: 'struktur_2', label: 'Kelengkapan tahapan alur' },
    ],
  },
];

export const RUBRIK_KETERANGAN = [
  { skor: 1, label: 'Tidak sesuai' },
  { skor: 2, label: 'Kurang sesuai' },
  { skor: 3, label: 'Sesuai' },
  { skor: 4, label: 'Sangat sesuai' },
];

export const SKOR_MAX_TOTAL = RUBRIK_ASPEK.reduce(
  (sum, a) => sum + a.indikator.length,
  0
) * 4;

export const RUBRIK_SCHEMA_KEY = RUBRIK_ASPEK[0].indikator[0].key;

export function buildEmptyIndikatorState() {
  const obj = {};
  for (const aspek of RUBRIK_ASPEK) {
    for (const ind of aspek.indikator) obj[ind.key] = '';
  }
  return obj;
}

export function buildEmptyRubrikState(overrides = {}) {
  return {
    namaSiswa: '',
    kelas: '',
    judulVideo: '',
    judulVideoId: '',
    tanggalPenilaian: new Date().toISOString().split('T')[0],
    catatanGuru: '',
    ...buildEmptyIndikatorState(),
    ...overrides,
  };
}

export function isValidRubrikData(data) {
  return data && typeof data === 'object' && Object.prototype.hasOwnProperty.call(data, RUBRIK_SCHEMA_KEY);
}

export function computeRubrikScore(rubrikData) {
  if (!rubrikData) return { totalSkor: 0, nilaiAkhir: 0, keterangan: 'Belum Dinilai' };

  let totalSkor = 0;
  for (const aspek of RUBRIK_ASPEK) {
    for (const ind of aspek.indikator) {
      const s = parseInt(rubrikData[ind.key] || 0, 10);
      if (s >= 1 && s <= 4) totalSkor += s;
    }
  }

  const nilaiAkhir = totalSkor > 0 ? Math.round((totalSkor / SKOR_MAX_TOTAL) * 100) : 0;
  let keterangan = 'Belum Dinilai';
  if (totalSkor > 0) {
    if (nilaiAkhir >= 81) keterangan = 'Sangat Baik 🏆';
    else if (nilaiAkhir >= 61) keterangan = 'Baik 👍';
    else if (nilaiAkhir >= 41) keterangan = 'Cukup ✅';
    else keterangan = 'Kurang 📝';
  }

  return { totalSkor, nilaiAkhir, keterangan };
}
